module.exports = __webpack_public_path__ + "static/media/meteocat.2e4e66d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/meteocat.svg
// module id = 108
// module chunks = 0